import React, { useEffect, useState } from 'react'
import { Link, navigate } from 'gatsby'
import { useAuthService } from 'theme/services/auth/auth-service'
// import { loginLinkedin } from 'src/utils/auth-helpers'
import { sendInBlueSubscribe } from 'src/components/subscribe'
import { MODES } from 'src/components/modals/login-modal'
import Select from 'react-select'

interface RegisterFormProps {
  url?: string
  changeMode?: (newMode: string) => void
  preventAutoRedirect?: (value: boolean) => void
}

interface Country {
  label: string
  value: string
}

const RegisterForm = ({ url, changeMode, preventAutoRedirect }: RegisterFormProps) => {
  // Fix the url prop if provided without trailing slash
  // if (url && url.charAt(url.length - 1) !== '/') {
  //   url += '/'
  // }
  const authService = useAuthService()
  // const loginLinkedinFunctions = loginLinkedin()

  const [isLoggingIn, setLoggingIn] = useState(false)
  const [manualError, setManualError] = useState('')
  const [socialError, setSocialError] = useState('')

  const [countries, setCountries] = useState([])
  const [selectedCountry, setSelectedCountry] = useState({} as Country)
  const [selectedState, setSelectedState] = useState({} as Country)

  const usStates = [
    { label: 'Alabama', value: 'AL' },
    { label: 'Alaska', value: 'AK' },
    { label: 'Arizona', value: 'AZ' },
    { label: 'Arkansas', value: 'AR' },
    { label: 'California', value: 'CA' },
    { label: 'Colorado', value: 'CO' },
    { label: 'Connecticut', value: 'CT' },
    { label: 'Delaware', value: 'DE' },
    { label: 'District of Columbia', value: 'DC' },
    { label: 'Florida', value: 'FL' },
    { label: 'Georgia', value: 'GA' },
    { label: 'Hawaii', value: 'HI' },
    { label: 'Idaho', value: 'ID' },
    { label: 'Illinois', value: 'IL' },
    { label: 'Indiana', value: 'IN' },
    { label: 'Iowa', value: 'IA' },
    { label: 'Kansas', value: 'KS' },
    { label: 'Kentucky', value: 'KY' },
    { label: 'Louisiana', value: 'LA' },
    { label: 'Maine', value: 'ME' },
    { label: 'Maryland', value: 'MD' },
    { label: 'Massachusetts', value: 'MA' },
    { label: 'Michigan', value: 'MI' },
    { label: 'Minnesota', value: 'MN' },
    { label: 'Mississippi', value: 'MS' },
    { label: 'Missouri', value: 'MO' },
    { label: 'Montana', value: 'MT' },
    { label: 'Nebraska', value: 'NE' },
    { label: 'Nevada', value: 'NV' },
    { label: 'New Hampshire', value: 'NH' },
    { label: 'New Jersey', value: 'NJ' },
    { label: 'New Mexico', value: 'NM' },
    { label: 'New York', value: 'NY' },
    { label: 'North Carolina', value: 'NC' },
    { label: 'North Dakota', value: 'ND' },
    { label: 'Ohio', value: 'OH' },
    { label: 'Oklahoma', value: 'OK' },
    { label: 'Oregon', value: 'OR' },
    { label: 'Pennsylvania', value: 'PA' },
    { label: 'Rhode Island', value: 'RI' },
    { label: 'South Carolina', value: 'SC' },
    { label: 'South Dakota', value: 'SD' },
    { label: 'Tennessee', value: 'TN' },
    { label: 'Texas', value: 'TX' },
    { label: 'Utah', value: 'UT' },
    { label: 'Vermont', value: 'VT' },
    { label: 'Virginia', value: 'VA' },
    { label: 'Washington', value: 'WA' },
    { label: 'West Virginia', value: 'WV' },
    { label: 'Wisconsin', value: 'WI' },
    { label: 'Wyoming', value: 'WY' },
  ]

  useEffect(() => {
    fetch('https://valid.layercode.workers.dev/list/countries?format=select&flags=true&value=code')
      .then((response) => response.json())
      .then((data) => {
        setCountries(data.countries)
        setSelectedCountry(data.userSelectValue)
      })
  }, [])

  // const handleLinkedinSuccess = async (data) => {
  //   if (typeof preventAutoRedirect === 'function') {
  //     preventAutoRedirect(true)
  //   }

  //   setManualError('')
  //   setSocialError('')
  //   try {
  //     setLoggingIn(true)
  //     const results = await loginLinkedinFunctions.getToken(data.code)
  //     await authService.loginWithToken(results.token)
  //     setLoggingIn(false)
  //     setShowQuestions(true)
  //   } catch (error: unknown) {
  //     setLoggingIn(false)
  //     // @ts-ignore
  //     setSocialError(error.message)
  //   }
  // }

  const loginWithProvider = async (provider) => {
    if (typeof preventAutoRedirect === 'function') {
      preventAutoRedirect(true)
    }
    setManualError('')
    setSocialError('')

    try {
      setLoggingIn(true)
      await authService.loginWithProvider(provider)
      setLoggingIn(false)
    } catch (error: unknown) {
      setLoggingIn(false)
      // @ts-ignore
      setSocialError(error.message)
    }
  }

  const handleForm = (evt) => {
    evt.preventDefault()

    registerUser()
  }

  const registerUser = async () => {
    if (typeof preventAutoRedirect === 'function') {
      preventAutoRedirect(true)
    }
    setManualError('')
    setSocialError('')

    //FIXME: we should not get values by html ids!
    const firstName = (document.getElementById('firstName') as HTMLInputElement).value
    const lastName = (document.getElementById('lastName') as HTMLInputElement).value
    const jobTitle = (document.getElementById('jobTitle') as HTMLInputElement).value
    const company = (document.getElementById('company') as HTMLInputElement).value
    const email = (document.getElementById('email') as HTMLInputElement).value
    const subscribe = (document.getElementById('subscribe') as HTMLInputElement).checked
    const subscribeEvents = (document.getElementById('subscribe-events') as HTMLInputElement).checked
    const country = selectedCountry?.value
    const state = selectedState?.value

    const newsletterObj = {
      emea: 20,
      usa: 21,
      apac: 19,
    }
    const newsletterIds = Object.keys(newsletterObj).map((obj) => newsletterObj[obj])

    let events: number[] = []
    if (subscribe) events.push(6)
    if (subscribeEvents) {
      // merge the events and newsletterIds
      events = [...events, ...newsletterIds]
    }

    if (events.length > 0) {
      try {
        sendInBlueSubscribe(
          email,
          'register',
          '/register',
          events,
          '',
          firstName,
          lastName,
          jobTitle,
          company,
          country,
          state,
        )
      } catch (e) {
        console.error(e)
      }
    } else {
      sendInBlueSubscribe(
        email,
        'register',
        '/register',
        [],
        '',
        firstName,
        lastName,
        jobTitle,
        company,
        country,
        state,
      )
    }
    try {
      setLoggingIn(true)
      const password = (document.getElementById('password') as HTMLInputElement).value
      await authService.register(firstName, lastName, jobTitle, company, email, password, country, state)
      if (url) {
        navigate(url)
        setLoggingIn(false)
      }
    } catch (error: unknown) {
      setLoggingIn(false)
      // @ts-ignore
      if (error.code === 'auth/user-not-found') {
        setManualError('That email address is not registered. Please register your account.')
      } else {
        // @ts-ignore
        setManualError(error.message)
      }
    }
  }

  return (
    <div className="mx-auto w-full">
      <div>
        <h2 className="mt-6 text-3xl leading-9 font-extrabold text-gray-900">Register for a UXDX account</h2>
      </div>

      <div className="mt-8">
        <div>
          <div>
            <button
              onClick={async () => await loginWithProvider('google')}
              type="button"
              className="px-6 py-3 w-full mt-4 font-semibold text-gray-900 bg-white border-2 border-gray-500 rounded-md shadow outline-none hover:bg-blue-50 hover:border-blue-400 focus:outline-none"
              aria-label="Sign in with Google"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="inline w-4 h-4 mr-3 text-gray-900 fill-current"
                viewBox="0 0 48 48"
                width="48px"
                height="48px"
              >
                <path
                  fill="#fbc02d"
                  d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12 s5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24s8.955,20,20,20 s20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
                ></path>
                <path
                  fill="#e53935"
                  d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039 l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
                ></path>
                <path
                  fill="#4caf50"
                  d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36 c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
                ></path>
                <path
                  fill="#1565c0"
                  d="M43.611,20.083L43.595,20L42,20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571 c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
                ></path>
              </svg>
              Sign in with Google
            </button>
          </div>

          {socialError && (
            <div className="rounded-md bg-red-50 p-4 mt-4">
              <div className="flex">
                <div className="flex-shrink-0">
                  {/* <!-- Heroicon name: x-circle --> */}
                  <svg
                    className="h-5 w-5 text-red-400"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <div className="ml-3">
                  <h3 className="text-sm leading-5 font-medium text-red-800">{socialError}</h3>
                </div>
              </div>
            </div>
          )}

          <div className="mt-6 relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-300" />
            </div>
            <div className="relative flex justify-center text-sm leading-5">
              <span className="px-2 bg-white text-gray-500">Or continue with</span>
            </div>
          </div>
        </div>

        <div className="mt-6">
          <form onSubmit={handleForm} className="space-y-6 text-left">
            <div>
              <label htmlFor="firstName" className="block text-sm font-medium leading-5 text-gray-700">
                First Name
              </label>
              <div className="mt-1 rounded-md shadow-sm">
                <input
                  id="firstName"
                  type="text"
                  required
                  autoFocus
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>
            </div>
            <div>
              <label htmlFor="lastName" className="block text-sm font-medium leading-5 text-gray-700">
                Last Name
              </label>
              <div className="mt-1 rounded-md shadow-sm">
                <input
                  id="lastName"
                  type="text"
                  required
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>
            </div>
            <div>
              <label htmlFor="jobTitle" className="block text-sm font-medium leading-5 text-gray-700">
                Job Title
              </label>
              <div className="mt-1 rounded-md shadow-sm">
                <input
                  id="jobTitle"
                  type="text"
                  required
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>
            </div>
            <div>
              <label htmlFor="company" className="block text-sm font-medium leading-5 text-gray-700">
                Company
              </label>
              <div className="mt-1 rounded-md shadow-sm">
                <input
                  id="company"
                  type="text"
                  required
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>
            </div>
            <Select
              options={countries}
              value={selectedCountry}
              isSearchable
              placeholder="Please select a country..."
              id="country"
              onChange={(selectedOption) => setSelectedCountry(selectedOption)}
            />
            {selectedCountry?.value === 'US' ? (
              <Select
                options={usStates}
                value={selectedState}
                isSearchable
                placeholder="Select a state..."
                id="state"
                onChange={(selectedOption) => setSelectedState(selectedOption)}
              />
            ) : null}
            <div>
              <label htmlFor="email" className="block text-sm font-medium leading-5 text-gray-700">
                Email address
              </label>
              <div className="mt-1 rounded-md shadow-sm">
                <input
                  id="email"
                  type="email"
                  required
                  autoComplete="username"
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>
            </div>
            <div>
              <label htmlFor="password" className="block text-sm font-medium leading-5 text-gray-700">
                Password
              </label>
              <div className="mt-1 rounded-md shadow-sm">
                <input
                  id="password"
                  type="password"
                  required
                  autoComplete="new-password"
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>
            </div>
            <div className="mt-6">
              <div className="flex items-center mb-4 mt-2 text-left">
                <input
                  id="subscribe"
                  type="checkbox"
                  className="form-checkbox mr-4 h-4 w-4 text-indigo-600 border border-gray-300 rounded-sm transition duration-150 ease-in-out"
                />
                <label htmlFor="subscribe" className="ml-2 block text-sm leading-5 text-gray-900">
                  Join 20,000 others who are scaling their careers with
                  <br />
                  weekly insights on Product, UX, Design and Dev
                </label>
              </div>
            </div>
            <div className="mt-6">
              <div className="flex items-center mb-4 mt-2 text-left">
                <input
                  id="subscribe-events"
                  type="checkbox"
                  className="form-checkbox mr-4 h-4 w-4 text-indigo-600 border border-gray-300 rounded-sm transition duration-150 ease-in-out"
                />
                <label htmlFor="subscribe-events" className="ml-2 block text-sm leading-5 text-gray-900">
                  Get exclusive offers and advance notication
                  <br />
                  about our events
                </label>
              </div>
            </div>
            <div className="flex items-center justify-between">
              <div className="text-sm leading-5">
                {changeMode && (
                  <button
                    type="button"
                    onClick={() => changeMode(MODES.LOGIN)}
                    className="font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition ease-in-out duration-150"
                  >
                    Sign In
                  </button>
                )}

                {!changeMode && (
                  <Link
                    to="/login/"
                    className="font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition ease-in-out duration-150"
                  >
                    Sign In
                  </Link>
                )}
              </div>

              <div className="text-sm leading-5">
                {changeMode && (
                  <button
                    type="button"
                    onClick={() => changeMode(MODES.FORGOT_PASSWORD)}
                    className="font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition ease-in-out duration-150"
                  >
                    Forgot your password?
                  </button>
                )}

                {!changeMode && (
                  <Link
                    to="/forgotpassword/"
                    className="font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition ease-in-out duration-150"
                  >
                    Forgot your password?
                  </Link>
                )}
              </div>
            </div>
            {manualError && (
              <div className="rounded-md bg-red-50 p-4">
                <div className="flex">
                  <div className="flex-shrink-0">
                    {/* <!-- Heroicon name: x-circle --> */}
                    <svg
                      className="h-5 w-5 text-red-400"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <h3 className="text-sm leading-5 font-medium text-red-800">{manualError}</h3>
                  </div>
                </div>
              </div>
            )}
            <div>
              <span className="block w-full rounded-md shadow-sm">
                <button
                  type="submit"
                  disabled={isLoggingIn}
                  // eslint-disable-next-line prettier/prettier
                  className={`
                    ${isLoggingIn ? 'bg-indigo-400' : 'bg-indigo-600 hover:bg-indigo-500'} 
                      w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white  focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out`}
                >
                  {isLoggingIn ? (
                    <>
                      <svg
                        className="animate-spin -ml-1 mr-2 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        />
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        />
                      </svg>
                      Logging in
                    </>
                  ) : (
                    'Register'
                  )}
                </button>
              </span>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default RegisterForm
